import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

export const Title: React.FC<{
  formLabel: string;
  validationMessage: string;
  placeholder: string;
}> = ({ formLabel, validationMessage, placeholder }) => {
  const {
    getValues,
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <FormControl isInvalid={!!errors.title?.message}>
      <FormLabel>{formLabel}</FormLabel>
      <Input
        type="text"
        {...register('title', {
          validate: (value) =>
            getValues('body').getCurrentContent().getPlainText().length > 0
              ? true
              : value.length > 0
              ? true
              : validationMessage,
          deps: ['body'],
        })}
        placeholder={placeholder}
        autoFocus={true}
      />
      <FormErrorMessage>{errors.title?.message}</FormErrorMessage>
    </FormControl>
  );
};
